import { ParsedUrlQuery } from 'querystring'
import { useSorter } from 'shared/route-query/hooks/use-sorter'
import { deepCompare } from 'shared/utils/deepCompare'

export const getSortQuery = <T extends string>({
  sort,
  defaultSort,
}: {
  sort: useSorter.SortInterface<T>
  defaultSort?: useSorter.SortInterface<T>
}) => {
  const newSortQuery = {} as ParsedUrlQuery

  if (deepCompare(sort, defaultSort)) return newSortQuery

  if (sort.sortColumn) {
    newSortQuery.sortColumn = sort.sortColumn
  }

  if (sort.sortDirection) {
    newSortQuery.sortDirection = sort.sortDirection
  }

  return newSortQuery
}
